import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import BusinessRestServices from '../../services/business-rest.service';
import Config from '../../utils/config.service';
import DialogServices from '../../services/dialog.service';
import RestService from '../../services/core-rest.service';
import Session from '../../utils/session.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';
import { ModalUpdateDependentInsuranceComponent } from '../modal-update-dependent-insurance/modal-update-dependent-insurance.component';
import { ModalUpdateWorkerAdditionalInfoComponent } from '../modal-update-worker-additional-info/modal-update-worker-additional-info.component';
import { ModalTerminateDependentComponent } from '../modal-terminate-dependent/modal-terminate-dependent.component';
import { Subscription, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	standalone: true,
	selector: 'table-dependents',
	templateUrl: './table-dependents.component.html',
	imports: [
		CommonModule, DatePipe, ArrayLimitToPipe, StartFromPipe, 
		TranslatePipe, ItemNoContentComponent, LoaderOverlayComponent, FormsModule
	]
})
export class TableDependentsComponent implements OnInit, OnDestroy {
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private config: Config = inject(Config);
	private dialogServices: DialogServices = inject(DialogServices);
	private restService: RestService = inject(RestService);
	private session: Session = inject(Session);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() pageSize: any | undefined;
	@Input() dependents: any;
	@Output() dependentsChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() currentPage: any | undefined;
	@Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	searchSubject: Subject<string> = new Subject<string>();
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
		
		this.searchSubject.pipe(
			debounceTime(500)
		).subscribe(searchTerm => {
			this.loadDependents(true);
		});
	}
	
	ngOnInit() {
		this.vm.user = this.session.getSession().user;
		this.vm.filter = {
			orderBy: 'created',
			ascending: false
		};
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.endReached = false;
		this.vm.includeInsurance = false;
		this.vm.loading = true;
		this.vm.canUserManuallyAddInsurance = this.session.canUserManuallyAddInsurance();
		this.loadDependents(true, true);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, "loadMorePages", () => {
				if (!this.vm.endReached) {
					this.loadDependents();
				}
			})
		);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, this.config.getBroadcastConfig().Dependents.ADDED, () => {
				this.loadDependents(true);
				this.vm.currentPage = 0;
			})
		);
		
		this.vm.loadDependents = this.loadDependents;
		this.vm.toggleActiveStatus = this.toggleActiveStatus;
		this.vm.deleteInvitation = this.deleteInvitation;
		this.vm.setFilter = this.setFilter;
		this.vm.hasInsurance = this.hasInsurance;
		this.vm.toggledIncludeInsurance = this.toggledIncludeInsurance;
		this.vm.updateInsurance = this.updateInsurance;
		this.vm.editAdditionalInfo = this.editAdditionalInfo;
		this.vm.editAdditionalInfo2 = this.editAdditionalInfo2;
		
		this.restService.getBusinessUserJoinRequests({ start: 0, pageSize: 20 })
			.then((response) => {
				console.log(response);
			})
			.catch((error) => {
				console.log(error);
			});
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	onSearchChange(searchTerm: string) {
		this.searchSubject.next(searchTerm);
	}
	
	hasInsurance() {
		return this.vm.user && this.vm.user.activeInsurancePolicies && this.vm.user.activeInsurancePolicies.length > 0;
	}
	
	toggledIncludeInsurance() {
		this.loadDependents(true);
		this.vm.currentPage = 0;
	}
	
	loadDependents(isInitial?, hasLoader?) {
		if (isInitial) {
			this.vm.endReached = false;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		var params: any = {
			pageSize: this.vm.pageSize * 2,
			start: (!isInitial && this.vm.dependents) ? this.vm.dependents.length : 0,
			orderBy: this.vm.filter.orderBy || 'created',
			ascending: this.vm.filter.ascending || false,
			includeInsurance: (this.hasInsurance() ? true : false)
		};
		if (this.vm.term && this.vm.term.trim() && this.vm.term.trim().length > 1) params.name = this.vm.term.trim();
		this.handleDownloadUrlUpdate();
		
		this.businessRestServices.getDependents(params, (dependents) => {
			if (dependents && dependents.length < this.vm.pageSize * 2) {
				this.vm.endReached = true;
			}
			if (isInitial) this.vm.currentPage = 0;
			if (hasLoader) {
				this.angularHelperService.createTimer(() => {
					this.vm.loading = false;
					this.vm.dependents = isInitial ? dependents : this.vm.dependents.concat(dependents);
					this.dependentsChange.emit(this.vm.dependents);
				}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
			} else {
				this.vm.dependents = isInitial ? dependents : this.vm.dependents.concat(dependents);
				this.dependentsChange.emit(this.vm.dependents);
			}
		});
	}
	
	setFilter(name) {
		this.vm.filter = this.vm.filter || {};
		this.vm.filter.ascending = this.vm.filter.orderBy === name ? !this.vm.filter.ascending : false;
		this.vm.filter.orderBy = name;
		
		this.loadDependents(true);
	}
	
	handleDownloadUrlUpdate() {
		var url: any = this.config.getRestUrl() + 'rest/business/worker/dependent/user-report.csv';
		var params: Array<any> = [];
		params.push("orderBy=" + (this.vm.filter.orderBy ? this.vm.filter.orderBy : "created"));
		params.push("ascending=" + (this.vm.filter.ascending ? this.vm.filter.ascending : false));
		if (this.vm.term && this.vm.term.trim() && this.vm.term.trim().length > 1) params.push("name=" + this.vm.term.trim());
		if (this.vm.includeInsurance) params.push("includeInsurance=true");
		
		this.vm.csvDownloadUrl = url + (params.length ? '?' + params.join('&') : '');
	}
	
	updateInsurance(dependent) {
		this.dialogServices.show({
			controller: ModalUpdateDependentInsuranceComponent,
			businessUserDependent: dependent,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
	}
	
	editAdditionalInfo(dependentInvitation) {
		dependentInvitation.isDependent = true;
		this.dialogServices.show({
			controller: ModalUpdateWorkerAdditionalInfoComponent,
			invitation: dependentInvitation,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
	}
	
	editAdditionalInfo2(dependentInvitation) {
		dependentInvitation.isDependent = true;
		this.dialogServices.show({
			controller: ModalUpdateWorkerAdditionalInfoComponent,
			invitation: dependentInvitation,
			isSecond: true,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
	}
	
	toggleActiveStatus(invitation) {
		if (!invitation || !invitation.dependent || invitation.processing) return;
		
		var user: any = this.session.getSession().user;
		
		if (user.businessUserType === 'BUSINESS_CLIENT') {
			if (invitation.existingTerminationDate == undefined) {
				if (invitation.dependent.terminationDate) {
					invitation.existingTerminationDate = this.angularHelperService.copy(invitation.dependent.terminationDate);
				} else {
					invitation.existingTerminationDate = false;
				}
			}
			this.dialogServices.show({
				controller: ModalTerminateDependentComponent,
				invitation: invitation,
				clickOutsideToClose: false,
				escapeToClose: false,
				multiple: false
			});
		}
	}
	
	deleteInvitation(invitation) {
		if (!invitation || invitation.processing) return;
		
		var dialog = this.dialogServices.confirmation({
			title: this.angularFilterHelperService.translate('Modal.Title.Confirm'),
			content: this.angularFilterHelperService.translate('Dependents.Confirm_Delete_Invitation')
				.replace('%s', invitation.firstName + ' ' + invitation.lastName),
		});
		dialog.afterClosed().subscribe((data) => {
			if (data) {				
				invitation.processing = true;
				var handleUpdate: any = () => {
					invitation.deleted = true;
					invitation.processing = false;
				};
				this.businessRestServices.deleteDependentInvitation({ invitationId: invitation.id }, handleUpdate);
			}
		});
	}
	
}